<template>
	<div class="custom-select-container">
		<div
			class="select-button"
			:class="{
				'is-open': isOpen,
			}"
			@click="isOpen = !isOpen"
		>
			<span class="select-button-label">{{
				value?.label || placeholder
			}}</span>
			<i class="select-button-icon fas fa-chevron-down"></i>
		</div>

		<ul
			v-if="isOpen"
			class="options-list"
		>
			<li
				v-for="option in options"
				:key="option.value"
				class="option-item"
				:class="{ selected: option.value === value.value }"
				@click="Select(option)"
			>
				{{ option.label }}
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'CustomSelect',
		props: {
			value: {
				type: [Object],
				default: null,
			},
			options: {
				type: Array,
				required: true,
			},
			interceptSelect: {
				type: Boolean,
				default: false,
			},
			placeholder: {
				type: String,
				default: 'SELECIONE UMA OPÇÃO',
			},
		},
		data() {
			return {
				isOpen: false,
			}
		},
		methods: {
			Select(option) {
				if (this.interceptSelect) {
					this.$emit('select', option)
				} else {
					this.$emit('input', option)
				}

				this.isOpen = false
			},
		},
	}
</script>

<style lang="scss" scoped>
	.custom-select-container {
		width: 100%;
		position: relative;

		.select-button {
			width: 100%;
			padding: 1.25rem 1rem;
			color: var(--newPrimaryActiveColor);
			background-color: var(--newPrimaryActiveBackgroundColor);
			border: 1px solid var(--newPrimaryActiveBackgroundColor);
			border-radius: 0.3rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			cursor: pointer;
			font-weight: 900;
			font-size: 1.5rem;
			line-height: 2rem;

			.select-button-label {
				width: 100%;
				text-align: center;
			}

			&:hover {
				color: var(--newPrimaryHoverColor);
				background-color: var(--newPrimaryHoverBackgroundColor);
				border-color: var(--newPrimaryHoverBackgroundColor);
			}

			.select-button-icon {
				transition: transform 0.1s ease-in-out;
			}

			&.is-open {
				.select-button-icon {
					transform: rotate(180deg);
				}
			}
		}

		.options-list {
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			max-height: calc(46vh);
			overflow-y: auto;
			background-color: var(--elementsBackgroundColor);
			border: 1px solid var(--elementsBorderColor);
			border-radius: 0.3rem;
			margin-top: 0.25rem;
			padding: 0;
			z-index: 10;

			.option-item {
				padding: 1rem 1rem;
				cursor: pointer;
				font-size: 1.25rem;
				list-style: none;
				border-top: 1px solid var(--elementsBorderColor);
				border-bottom: 1px solid var(--elementsBorderColor);
				border-radius: 0.125rem;
				text-align: center;
				font-weight: 900;
				font-size: 1.25rem;
				line-height: 1.75rem;

				&:hover {
					background-color: var(--newPrimaryActiveBackgroundColor);
					color: var(--newPrimaryActiveColor);
				}
			}
		}
	}

	::-webkit-scrollbar {
		width: 10px;
	}

	::-webkit-scrollbar-thumb {
		background-color: var(--newPrimaryBackgroundColor);

		&:hover {
			background-color: var(--newPrimaryHoverBackgroundColor);
		}
	}
</style>
